(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  const wrap = document.querySelector('.rh-tabs');
  if(!wrap) return;
  const links = wrap.querySelectorAll('.rh-tablink');
  const panels = wrap.querySelectorAll('.rh-tabpanel');

  links.forEach(function(btn){
    btn.addEventListener('click', function(){
      const target = btn.getAttribute('data-tab');
      links.forEach(function(b){ b.classList.remove('is-active'); });
      panels.forEach(function(p){ p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      const panel = wrap.querySelector('.rh-tabpanel[data-tab="'+target+'"]');
      if(panel){ panel.classList.add('is-active'); }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
